module.exports = __webpack_public_path__ + "static/advantages_why_bg_mobile-4540c20140ca1824812c8f1a29341653.svg";